import React from 'react';
import { Tag, Typography } from 'antd';
import { formatDate } from '../../utils/applicationDisplayFormat';
import { ENTITY_CARD_DASH } from '../../utils/entityCardRouteUtils';
import { STATUS_MAP } from '../Status/StatusTag';

const { Text } = Typography;

/** Минимальные поля маршрута и опционально снимок договора с перевозчиком (с бэка). `null`/`undefined` — нет значения. */
export type ExecutionCellRoute = {
  isCompanyRoute?: boolean;
  carrierContractRequestNumber?: string | null;
  carrierContractRequestDate?: string | null;
  carrierAgreement?: { number?: string | null; date?: string | null } | null;
};

export type ExecutionCellProps = {
  route: ExecutionCellRoute;
};

/**
 * Как исполнялся маршрут: свой автопарк / договор-заявка с перевозчиком.
 * Не смешивает с договором клиента (это отдельные сущности в карточке заявки).
 */
export const ExecutionCell: React.FC<ExecutionCellProps> = ({ route }) => {
  if (route.isCompanyRoute === true) {
    return <Tag color={STATUS_MAP.COMPLETED.color}>Свой</Tag>;
  }

  const fromAgreement = route.carrierAgreement;
  const num =
    String(route.carrierContractRequestNumber ?? '').trim() ||
    (fromAgreement?.number && String(fromAgreement.number).trim()) ||
    '';
  const dateRaw = route.carrierContractRequestDate ?? fromAgreement?.date;
  const dateLine = dateRaw != null && String(dateRaw).trim() !== '' ? formatDate(String(dateRaw)) : ENTITY_CARD_DASH;

  if (num && dateLine !== ENTITY_CARD_DASH) {
    return (
      <Text>
        №{num} от {dateLine}
      </Text>
    );
  }

  if (num) {
    return <Text>№{num}</Text>;
  }

  return <Text type="secondary">{ENTITY_CARD_DASH}</Text>;
};

export default ExecutionCell;
